import React, { useEffect, useState } from 'react';
import { ReactComponent as WarningRed } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import { Input } from 'antd';
import { Select } from 'components';
import { createGroup, createUser, getGroupById, getGroups, getPrivilegesByGroup } from 'store/adminPanel/actions';
import { useDispatch } from 'react-redux';

const CreateModal = ({ isVisible, setVisible, groups }) => {

    const dispatch = useDispatch();
    const [groupID, setGroupID] = useState("");
    const [groupName, setGroupName] = useState("");
    const [groupType, setGroupType] = useState("");

    const [error, setError] = useState(true);
    const [errorName, setErrorName] = useState(false);
    const [errorId, setErrorId] = useState(false);
    console.log("groups:",groups.map(group=>group.id).includes(groupID));
    console.log("groupID:",typeof(groupID));

    useEffect(()=>{
        if (!groupID || !groupName || !groupType){
            setError(true);
            setErrorName(false);
            setErrorId(false);
        } else if (groups.map(group=>group.id).includes(groupID)){
            setError(false);
            setErrorName(false);
            setErrorId(true);
        } else if (groupID !== groupName){
            setError(false);
            setErrorName(true);
            setErrorId(false);
        } else {
            setError(false);
            setErrorName(false);
            setErrorId(false);
        }
    },[groupID, groupName, groupType]);

    const handleClose = () => {
        setVisible(false);
        setGroupID("");
        setGroupName("");
        setGroupType("");
    }
    const handleOk = () => {
        dispatch(createGroup(groupID, groupName, groupType));
        setVisible(false);
        setGroupID("");
        setGroupName("");
        setGroupType("");
    }

    return (
      <Modal
        isVisible={isVisible}
        Icon={WarningRed}
        onCancel={() => handleClose()}
        onOk={() => handleOk()}
        // okButtonProps={{disabled:error || errorId || errorEmail}}
        title={<h1 style={{color:"#2d97e9", marginTop:"0.563rem", marginLeft:"1.875rem"}}>Create Group</h1>}
        width={817}
        okText="Create Group"
      >
        <div>
            {error && <span style={{color:"#f76b8a"}}>Παρακαλώ συμπληρώστε όλα τα πεδία</span>}
        </div>
        <div>
            {errorId && <span style={{color:"#f76b8a"}}>Το Group ID υπάρχει ήδη</span>}
        </div>
        <div>
            {errorName && <span style={{color:"#f76b8a"}}>Το Νame πρέπει να είναι ίδιο με το Group ID</span>}
        </div>
        
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Group ID</span>
            <Input style={{height:"40px"}} value={groupID} onChange={event=>setGroupID(event.target.value)}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Name</span>
            <Input style={{height:"40px"}} value={groupName} onChange={event=>setGroupName(event.target.value)}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Type</span>
            <Input style={{height:"40px"}} value={groupType} onChange={event=>setGroupType(event.target.value)}></Input>
        </div>
 
      </Modal>
    );
  };
  export default CreateModal;